/* eslint-disable global-require */
/* eslint-disable no-unused-vars */
import React from "react";
import { useFeatures } from "@paralleldrive/react-feature-toggles";
import { useIntl } from "react-intl";
import { useCongress, useUserMe } from "../../hooks";
import { ReactComponent as CoursesSvg } from "../../assets/icons/courses.svg";
import { ReactComponent as AgendaSvg } from "../../assets/icons/agenda.svg";
import { ReactComponent as MeetTheExpertSvg } from "../../assets/icons/meet the expert.svg";
import { ReactComponent as SessionSvg } from "../../assets/icons/session.svg";
import { ReactComponent as CompaniesSvg } from "../../assets/icons/companies.svg";
import { ReactComponent as EpostersSvg } from "../../assets/icons/eposters.svg";
import { ReactComponent as ForumSvg } from "../../assets/icons/forum.svg";
import { ReactComponent as SocialWallSvg } from "../../assets/icons/social wall.svg";
import { ReactComponent as SpeakerSvg } from "../../assets/icons/speaker.svg";

const GetAvailableCongressLinks = (extraLinks = []) => {
  const intl = useIntl();
  const features = useFeatures();
  const { congress } = useCongress();
  const { user } = useUserMe();
  const links = [
    {
      label: intl.formatMessage({ id: "Pages.HomePage.Program", defaultMessage: "Program" }),
      icon: AgendaSvg,
      route: "/program",
      featureName: "program"
    },
    {
      label: intl.formatMessage({ id: "Pages.HomePage.Sessions", defaultMessage: "Sessions" }),
      icon: SessionSvg,
      route: "/sessions",
      featureName: "sessions"
    },
    {
      label: intl.formatMessage({
        id: "Pages.HomePage.Exhibitors",
        defaultMessage: "Exhibitors"
      }),
      icon: CompaniesSvg,
      route: "/companies",
      featureName: "companies"
    },
    {
      label: intl.formatMessage({
        id: "Pages.HomePage.Experts",
        defaultMessage: "Invited Speakers"
      }),
      icon: SpeakerSvg,
      route: "/experts",
      featureName: "experts"
    },
    {
      label: intl.formatMessage({ id: "Pages.HomePage.EPosters", defaultMessage: "E-Posters" }),
      icon: EpostersSvg,
      route: "/e-posters",
      featureName: "eposters"
    },
    {
      label: intl.formatMessage({ id: "Pages.HomePage.Forum", defaultMessage: "Forum" }),
      icon: ForumSvg,
      route: "/forum",
      featureName: "forum"
    },
    {
      label: intl.formatMessage({ id: "Pages.HomePage.SocialWall", defaultMessage: "Social Wall" }),
      icon: SocialWallSvg,
      route: "/social-wall",
      featureName: "socialwall"
    }
  ];

  return links
    .concat(extraLinks)
    .filter(
      x =>
        features.includes(x.featureName) && (user.hasRoles(["admin", "organizer"]) || congress.open)
    );
};

const GetAvailableLearnLinks = (extraLinks = []) => {
  const intl = useIntl();
  const features = useFeatures();
  const { congress } = useCongress();
  const { user } = useUserMe();

  const links = [
    {
      label: intl.formatMessage({ id: "Pages.HomePage.Learn.Courses", defaultMessage: "Courses" }),
      icon: CoursesSvg,
      route: "/learn/courses"
    },
    {
      label: intl.formatMessage({
        id: "Pages.HomePage.Learn.AskToTeacher",
        defaultMessage: "Ask To Teacher"
      }),
      icon: MeetTheExpertSvg,
      route: "/learn/teachers"
    }
  ];

  return links
    .concat(extraLinks)
    .filter(
      x =>
        (x.featureName === undefined || features.includes(x.featureName)) &&
        (user.hasRoles(["admin", "organizer"]) || congress.open)
    );
};

const GetAvailableLinks = extraLinks => {
  const { congress } = useCongress();

  return congress.enableFeatureLearn
    ? GetAvailableLearnLinks(extraLinks)
    : GetAvailableCongressLinks(extraLinks);
};

export default GetAvailableLinks;
